<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-5 small pl-1 pr-1 mb-0 pb-0">
            <div class="card col-md-6 p-0">
                <div class="card-header small pt-0 pb-0" :style="{ backgroundColor: moduloAtual().color }">
                    <span class="m-0 font-weight-bold text-white">
                        MOVIMENTAÇÃO DE-PARA
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </span>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light small pl-2 pr-2 pt-2 pb-1">
                        <div class="mt-2">
                            <InputDefaultApp
                                inputPlaceHolderSufixo="Digite o endereço de origem"
                                titleScan="Escanear Origem"
                                typeInputMode="text"
                                @displayScanFunction="dialogoBuscaProdutos"
                                :enterKey="(e) => dialogoBuscaProdutos(e.target.value)"
                                idInput="enderecoOrigemInput"
                                :errorMessage="this.enderecoOrigemErrorMessage"
                                :toUpperCase="true"
                            >
                            </InputDefaultApp>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <LogoutModal />
        <div class="container-img mt-1 small pl-1 pr-1 mb-0 pb-0" v-if="this.produtosCarregados">
            <div class="card col-md-6 p-0">
                <div class="card-header bg-success small pt-0 pb-0">
                    <span class="m-0 font-weight-bold text-white">
                        PRODUTOS
                    </span>
                </div>
                <div class="card-body bg-transparent small p-1">
                    <div class="scrollview">
                        <div v-for="(item) in this.dados" :key="item.idprodutos">
                            <table class="table table-bordered m-0 mt-1">
                                <thead>
                                    <tr>
                                        <th class="bg-light text-left small font-weight-bold pt-1 pb-1">
                                            {{  item.produtodescricao }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left pt-1">
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Cliente
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5 text-danger">
                                                    {{ item.fantasia }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    SKU
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ item.sku }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Código Barras
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ item.codbarras }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Qtde
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ item.qtde }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Lote
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ item.lote }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Validade
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ dateFormat(item.validade) }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    Valor R$
                                                </div>
                                                <div class="col-5 col-md-5 col-lg-5">
                                                    {{ moneyFormat(item.valorcusto) }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-img mt-1 small pl-1 pr-1 mb-0 pb-0" v-if="this.produtosCarregados">
            <div class="card col-md-6 p-0">
                <div class="card-header bg-primary small pt-0 pb-0">
                    <span class="m-0 font-weight-bold text-white">
                        ENDEREÇO DESTINO
                    </span>
                </div>

                <div class="card-body bg-light small pl-2 pr-2 pt-2 pb-0">
                    <div class="mt-2">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite o endereço destino"
                            titleScan="Escanear Destino"
                            typeInputMode="text"
                            @displayScanFunction="buscarEnderecoDestino"
                            :enterKey="(e) => buscarEnderecoDestino(e.target.value)"
                            idInput="enderecoDestinoInput"
                            :errorMessage="this.enderecoDestinoErrorMessage"
                            :toUpperCase="true"
                        >
                        </InputDefaultApp>
                    </div>
                </div>

                <div class="card-footer pt-0 pb-0 border-top-0">
                    <div class="row">
                        <div class="col-6 col-md-6 col-lg-6 p-1 m-0">
                            <button id="btnMovimentar" disabled class="btn btn-sm btn-block btn-success" @click="() => dialogoMovimentar()">
                                Movimentar
                                <em class="fa fa-random ml-2"></em>
                            </button>  
                        </div>
                        <div class="col-6 col-md-6 col-lg-6 p-1 m-0">
                            <button id="btnCancelar" class="btn btn-sm btn-block btn-danger" @click="() => clear()">
                                Cancelar
                                <em class="fa fa-ban ml-2"></em>
                            </button>  
                        </div>
                    </div>
                  
                </div>
            </div>
        </div>
        <div v-if="!this.produtosCarregados" class="text-center text-secondary mt-5">
            <em class="mt-2 mb-3 fa fa-info-circle fa-3x"></em>
            <h6>Bipe o endereço ex: 1A.PPL.13.01.A</h6>
        </div>

        <Modal
            id="modal1"
            title="Atenção!"
            :confirmFunction="() => buscarProdutosOrigem()"
            :cancelFunction="() => closeModal('modal1')"
            :carregando="carregando"
        >
            <div class="small">
                <strong>
                    <h6>O endereço DE: <code id="codeEnderecoOrigem"></code></h6>
                </strong>
                <h6>Será bloqueado como pulmão. Clique em Prosseguir para continuar a movimentação</h6>
            </div>
        </Modal>

        <Modal
            id="modal2"
            title="Atenção!"
            :confirmFunction="() => movimentar()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modal2')"
        >
            Confima a movimentação?
            <br>
            <br>
            Todos os produtos do endereço de origem serão transferidos para o endereço de destino!
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>
    </div>
</template>
  
  
<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import InputDefaultApp from '../components/InputDefaultApp.vue';
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api from '../services/api'
import { getUsername, getPerfil, getUserId } from "../services/api";
import { moneyFormat, dateFormat } from "../utils";
import Modal from "../components/Modal.vue";
import $ from "jquery";
import audioService from '@/services/audioService.js';

export default {
    name: 'Categoria',
    mixins: [
        ViewMixin
    ],
    components: {
        Topbar,
        LogoutModal,
        Modal,
        InputDefaultApp,
    },
  
    data: () => {
        return {
            dados: null,
            enderecoOrigemReferencia: null,
            enderecoDestinoReferencia: null,
            enderecoOrigemErrorMessage: "",
            enderecoDestinoErrorMessage: "",
            produtosCarregados: false,
            scanAberto: false,
            retornoMessage: '',
        };
    },
  
    async mounted() {
        try {
            await this.validarToken();
            setTimeout(() => {
                document.getElementById('enderecoOrigemInput').focus();
            }, 500);
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },
  
    methods: {
        getUsername,
        getUserId,
        getPerfil,
        moneyFormat,
        dateFormat,

        playSound() {
            audioService.ops();
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        onModalClosed() {
            let enderecoOrigemInput = document.getElementById("enderecoOrigemInput");
            let enderecoDestinoInput = document.getElementById("enderecoDestinoInput");

            if (enderecoOrigemInput !== null && enderecoOrigemInput !== undefined) {
                if (!enderecoOrigemInput.disabled) {
                    enderecoOrigemInput.focus();
                    enderecoOrigemInput.select();
                }
            }
            if (enderecoDestinoInput !== null && enderecoDestinoInput !== undefined) {
                if (!enderecoDestinoInput.disabled) {
                    enderecoDestinoInput.focus();
                    enderecoDestinoInput.select();
                }
            }
        },

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        async dialogoBuscaProdutos() {
            try {
                let endereco = document.getElementById('enderecoOrigemInput').value;
                let response1 = await api.get("/movimentacao/endereco/"+btoa(endereco));

                if (JSON.stringify(response1.data).includes("descricao"))
                {
                    if (response1.data.descricao === endereco) {
                    
                        this.enderecoOrigemReferencia = response1.data;
                        $("#modal1").modal('show');
                        $("#codeEnderecoOrigem").text($('#enderecoOrigemInput').val());
                        this.enderecoOrigemErrorMessage = "";
                    }
                } else {
                    this.enderecoOrigemReferencia = null;
                    this.enderecoOrigemErrorMessage = "Endereço não encontrado!";
                    this.produtosCarregados = "";
                    this.dados = null;
                }
            } catch (e) {
                this.enderecoOrigemErrorMessage = "Endereço não encontrado!";
                this.produtosCarregados = false;
                document.getElementById('enderecoOrigemInput').select();
                document.getElementById('enderecoOrigemInput').focus();
                this.playSound();
            }
        },
  
        async buscarProdutosOrigem() {
            let endereco = document.getElementById('enderecoOrigemInput').value;

            this.closeModal("modal1");
            this.carregando = true;

            try {
                let response2 = await api.post("/movimentacao/produtos/endereco", {
                    descricao: endereco,
                    tipo: "ORIGEM",
                    idUsuario: getUserId()
                });

                this.produtosCarregados = true;
                this.dados = response2.data;

                document.getElementById('enderecoOrigemInput').disabled = true;
            
                setTimeout(() => {
                    document.getElementById('enderecoDestinoInput').focus();
                }, 1000);
            } catch (e) {
                this.produtosCarregados = false;
                this.enderecoOrigemErrorMessage = e.message;

                setTimeout(() => {
                    $('#enderecoOrigemInput').focus();
                    $('#enderecoOrigemInput').select();
                }, 250);

                this.playSound();
            }
            this.carregando = false;
        },

        async buscarEnderecoDestino(endereco) {
            this.carregando = true;

            if (endereco === document.getElementById('enderecoOrigemInput').value) {
                this.carregando = false;
                document.getElementById('enderecoDestinoInput').select();
                document.getElementById('enderecoDestinoInput').focus();
                this.enderecoDestinoErrorMessage = "O endereço de destino não pode ser igual ao endereço de origem!";
                this.playSound();
                return;
            }

            try {
                let response = await api.get("/movimentacao/endereco/"+btoa(endereco));

                if (JSON.stringify(response.data).includes("descricao"))
                {
                    if (response.data.descricao !== endereco) {
                        this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                        setTimeout(() => {
                            $('#enderecoDestinoInput').focus();
                            $('#enderecoDestinoInput').select();
                        }, 250);
                        this.enderecoDestinoReferencia = null;
                        this.playSound();
                    } else {
                        document.getElementById("btnMovimentar").disabled = false;
                        this.enderecoDestinoErrorMessage = "";
                        this.enderecoDestinoReferencia = response.data;
                    }
                }
            } catch (e) {
                this.enderecoDestinoErrorMessage = "Endereço não encontrado!";

                setTimeout(() => {
                    $('#enderecoDestinoInput').focus();
                    $('#enderecoDestinoInput').select();
                }, 250);

                this.playSound();
            }
            this.carregando = false;
        },

        clear() {
            this.dados = null;
            this.produtosCarregados = false;
            this.enderecoDestinoErrorMessage = "";
            document.getElementById('enderecoOrigemInput').value = "";
            document.getElementById('enderecoDestinoInput').value = "";
           
            document.getElementById("btnMovimentar").disabled = true;
            document.getElementById("btnCancelar").disabled = false;
            document.getElementById('enderecoOrigemInput').disabled = false;
            document.getElementById('enderecoOrigemInput').focus();
        },

        dialogoMovimentar() {
            if ($('#enderecoDestinoInput').val().trim() === "") {
               document.getElementById('enderecoDestinoInput').style.border = "1px solid red";
            } else {
                document.getElementById('enderecoDestinoInput').style.border = "";
                $("#modal2").modal("show");
            }
        },

        async movimentar() {
            this.closeModal("modal2");
            document.getElementById("btnMovimentar").disabled = true;
            document.getElementById("btnCancelar").disabled = true;

            this.carregando = true;

            try {

                let response = await api.post("/movimentacao/depara", {
                    enderecoOrigem: this.enderecoOrigemReferencia.descricao,
                    enderecoDestino: this.enderecoDestinoReferencia.descricao,
                    quarentena: this.enderecoOrigemReferencia.quarentena,
                    pulmao: this.enderecoOrigemReferencia.pulmao,
                    idUsuario: getUserId()
                });

                if (response.status === 200) {
                    this.showMessageSuccess("Produtos movimentados com sucesso!");
                    this.clear();
                }
            } catch(e) {
                this.enderecoDestinoErrorMessage = e.message;
                document.getElementById("btnMovimentar").disabled = false;
                document.getElementById("btnCancelar").disabled = false;
                this.playSound();
            }

            this.carregando = false;
        },
    }
}
</script>
  
<style scoped lang="scss">    
  
    .home-view {
        height: 100%;
    }
  
    .container-img {
        height: auto;
        display: flex;
        justify-content: center;
        align-self: center;
    }
  
    .icon-input {
        position: absolute;
        top: 20%;
        right: 30px;
        font-size: 18px;
    }

    .icon-cam {
        position: absolute;
        top: 20%;
        right: 5px;
        font-size: 18px;
    }

    .icon-status {
        position: absolute;
        top: 5%;
        right: 3%;
    }

    .main {
        padding-top: 75px;
    }

    .scrollview {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 180px;
    }

    @media (max-height: 840px) {
        .scrollview {
            max-height: 520px;
        }
    }

    @media (max-height: 800px) {
        .scrollview {
            max-height: 480px;
        }
    }

    @media (max-height: 768px) {
        .scrollview {
            max-height: 450px;
        }
    }

    @media (max-height: 700px) {
        .scrollview {
            max-height: 380px;
        }
    }

    @media (max-height: 680px) {
        .scrollview {
            max-height: 360px;
        }
    }

    @media (max-height: 640px) {
        .scrollview {
            max-height: 320px;
        }
    }

    @media (max-height: 600px) {
        .scrollview {
            max-height: 280px;
        }
    }

    @media (max-height: 580px) {
        .scrollview {
            max-height: 260px;
        }
    }

    @media (max-height: 540px) {
        .scrollview {
            max-height: 220px;
        }
    }

    @media (max-height: 500px) {
        .scrollview {
            max-height: 180px;
        }
    }

    @media (max-height: 470px) {
        .scrollview {
            max-height: 140px;
        }
    }
</style>
  